<template>
    <router-view v-if="faqLoaded"></router-view>
</template>

<script>
import { mapGetters } from 'vuex';
import { mountKareScript, removeKare } from '@/helpers/KareScriptHelpers';

export default {
    name: 'Faq',
    created() {
        this.$store.dispatch('faq/fetchAnswers');
        this.$store.dispatch('faq/fetchCategories');
    },
    computed: {
        ...mapGetters({
            enableKareWidget: 'localisation/enableKareWidget',
        }),
        faqLoaded() {
            return this.$store.getters['faq/getCategories'].length && this.$store.getters['faq/getAnswers'].length;
        },
    },
    mounted() {
        this.enableKareWidget && mountKareScript(document);
    },
    beforeDestroy() {
        this.enableKareWidget && removeKare(document);
    },
};
</script>
